(function () {
    var superproto = GUI.Application.prototype;

    GUI.View = Class.create();
    Object.extend(GUI.View.prototype, superproto);

    /**
     * Type of the module, default is 'View'
     * @type String
     */
    GUI.View.prototype.type = 'View';

    /**
     * Initializes view
     * @param {Object} config
     */
    GUI.View.prototype.initialize = function (config) {
        Object.extend(this, config);
        superproto.create.call(this);
    };

    /**
     * Returns view by the name
     * @param {String} name of the view
     */
    GUI.View.prototype.getView = function (name) {
        if (!GUI.isSet(name)) {
            return;
        }
        return superproto.getModule.call(this, 'View', name);
    };

    /**
     * Returns model by the name
     * @param {String} name of the model
     */
    GUI.View.prototype.getModel = function (name) {
        if (!GUI.isSet(name)) {
            return;
        }
        return superproto.getModule.call(this, 'Model', name);
    };

    /**
     * Returns controller by the name
     * @param {String} name of the controller
     */
    GUI.View.prototype.getController = function (name) {
        if (!GUI.isSet(name)) {
            return;
        }
        return superproto.getModule.call(this, 'Controller', name);
    };

}());